import { Reducer } from 'redux';
import { HomeCampaignsState, HomeCampaignsTypes } from './types';

const INITIAL_STATE: HomeCampaignsState = {
  data: [],
  loading: false,
};

const reducer: Reducer<HomeCampaignsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeCampaignsTypes.HOME_CAMPAIGNS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HomeCampaignsTypes.HOME_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        data: action.payload.data,
      };
    case HomeCampaignsTypes.HOME_CAMPAIGNS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
